import { createReducer, on } from '@ngrx/store';
import * as CurrentUserActions from '../actions/current-user.actions';

export const userFeatureKey = 'currentUser';

export interface State {
  record: any;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};

export const reducer = createReducer(
  initialState,

  on(CurrentUserActions.loadCurrentUser, (state) => ({
    record: state.record,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(CurrentUserActions.loadCurrentUserSuccess, (state, action) => ({
    record: action.data['data'],
    error: null,
    loaded: true,
    loading: false,
  })),
  on(CurrentUserActions.loadCurrentUserFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(CurrentUserActions.clearCurrentUserState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);
